import { useMutation, useQueryClient } from "@tanstack/react-query";

import { postProjectsProjectIDActors } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";
import { PROJECTS_QUERY_KEYS } from "Projects/Api/Queries/queryKeys";

export function useSyncProjectActorsMutation(projectId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse(
      (actorIDs: string[]) =>
        postProjectsProjectIDActors({ actorIDs }, projectId),
      {
        translationPrefix: getResourcePath(
          Resources.ApiErrors.SyncProjectActors,
        ),
      },
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PROJECTS_QUERY_KEYS.detail(projectId),
      });
    },
  });
}
